<template>
  <v-form @submit.prevent="addEditProjectTask" ref="form">
     <v-card dense style="border-radius:4px;">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold ">{{mode}} Project Task</span>
            <v-spacer></v-spacer>
            <help-link appId="projects" pageId="projectcharges-daily" color="black"></help-link>
            <v-btn icon @click.native="closeDialog" :disabled="disabled" >
                <v-icon >close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text>
            <v-alert v-if="context.status==2" :value="true" color="warning" icon="warning" outline style="margin:0px 20px 10px 20px;">
                This has been approved already. Clicking Save will update back to For Review.
            </v-alert>  
            <p v-if="error" style="color:red;">{{ errorMessage }}</p>    
            <v-layout row wrap>
                <v-flex xs12 sm12 style="padding:10px 25px 0px 25px;" >   
                    <v-layout row >  
                        <v-flex xs3>
                            <b>Date:</b>
                        </v-flex> 
                        <v-flex xs9>
                            <span v-if="mode=='Add'">{{transDate | moment('YYYY-MM-DD')}}</span>
                            <span v-else>{{context.transDate | moment('YYYY-MM-DD')}}</span>
                        </v-flex>      
                    </v-layout>    
                    <v-layout row style="margin-top:10px;">
                        <v-flex xs12>
                            <v-autocomplete
                                v-model="context.projectId"
                                :disabled="disabled"
                                :items="project_list"
                                :loading="loading"
                                :rules="[rules.required]"
                                color="blue-grey lighten-2"
                                label="Project"
                                item-text="projectName"
                                item-value="projectId"
                                @change="setProjectTasks"
                                >
                            </v-autocomplete>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs12>
                            <v-autocomplete
                                v-model="context.projectTaskId"
                                :disabled="disabled"
                                :items="projecttask_list"
                                :loading="loading"
                                :rules="[rules.required]"
                                color="blue-grey lighten-2"
                                label="Task"
                                item-text="taskName"
                                item-value="projectTaskId"
                                >
                            </v-autocomplete>
                        </v-flex>
                    </v-layout>
                    <v-layout v-if="mode=='Add'" row wrap>
                        <v-flex xs12>
                            <v-select
                                label="Recurrence"
                                :items="recurrence_list"
                                :rules="[rules.required]" 
                                item-text="description"
                                item-value="recurrence"
                                :disabled="disabled"
                                v-model="context.recurrence"                  
                            ></v-select>
                        </v-flex>
                    </v-layout>                  
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-text-field 
                                label="Hours"
                                v-model="context.hours" 
                                :rules="[rules.required]" 
                                :disabled="disabled"
                                type="number" min="0" max="10" step="0.25" value="0.00"
                                @blur="formatHours"
                                ></v-text-field>  
                            <div style="margin-top:-20px;" class="text-xs-right"><small>In decimal format. (1.5 = 1hour 30mins)</small></div>
                        </v-flex>                        
                    </v-layout>
                    <v-layout row v-if="showComment"> 
                        <v-flex xs12>
                            <v-textarea v-model="context.remarks" label="Remarks" rows="2" color="primary"></v-textarea>
                        </v-flex>      
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card-text>  
        <v-divider></v-divider>
        <v-card-actions> 
            <v-spacer></v-spacer>
            <v-btn icon @click="showComment=!showComment" title="Add Comment">
                <v-icon>comment</v-icon>
            </v-btn>
            <v-btn color="primary" type="submit" :loading="loading" style="color:white">
                <span v-if="mode=='Add'">Save</span>
                <span v-if="mode=='Edit'">Update</span>
            </v-btn>
            <v-btn v-if="mode!='Edit'" @click="clearForm" :disabled="disabled" >clear</v-btn>
        </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>

import projectsApi from '@/api/projects'
import projectChargesApi from '@/api/projectcharges'
import commonfn from '@/common/functions'

export default {
    name: 'addEditProjectCharges',
    data () {
        return {
        error: false,
        errorMessage: '', 
        loading: false,
        disabled: false,
        error: false,  
        avatarPath: '',           
        rules: {
            required: value => !!value || 'Required.',
            min: v => v.length >= 8 || 'Min 8 characters',
            counter: value => value.length <= 20 || 'Max 20 characters',
            email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
            } 
        },
        mode: '',
        transDate: null,
        projectId: '',
        projectTaskId: '',
        projectChargesId: 0,
        code: '',
        description: '',      
        hours: null,
        project_list: [],
        projecttask_list: [],
        context: [],
        showComment: false,
        statusList: [
                {Status: 1, Description: 'For Approval'},
                {Status: 2, Description: 'Approved'},
                {Status: 3, Description: 'Rejected'},
                {Status: 4, Description: 'Cancelled'},
            ],
        recurrence: 1,
        recurrence_list: [
            {recurrence: 1, description: 'This day only'},
            {recurrence: 2, description: 'For whole cut-off period'},
        ]
        }
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    methods: {     
        getStatusDesc(status){            
            var description = this.statusList.filter(item => {
                return item.Status == status
            })[0]//.Description
            
            if (description==undefined) return ''
            else return description.Description
        },   
        formatHours() {
            if (this.context.hours!=null) {
                var test = parseFloat(this.context.hours).toFixed(2);
                this.context.hours = test
            }
        },
        setProjectTasks() {
            var task = []
            var project = this.project_list.filter(x=>{
                return x.projectId == this.context.projectId
            })[0]
            if (project) {
                task = project.projectTasks
            }
            this.projecttask_list = task
        },
        closeDialog() {
            this.clearForm()
            this.$emit('update:dialogProjectTask', false)
        },
        setParamsAdd(data) {           
            this.mode = 'Add'           
            this.transDate = data.transDate
            this.context = []
        },
        setParamsEdit(data) {
            this.mode = 'Edit'
            this.transDate = data.transDate
            this.context = data.items
            this.context.hours = data.items.hours //eval(data.items.hours).toFixed(2)
            
            this.setProjectTasks()
        },
        async addEditProjectTask() {         
            if (this.$refs.form.validate()) {
                try {
                    this.loading = true
                    this.disabled = true
                    
                    var data = {
                        projectChargesId: this.mode=='Add'?"0":this.context.projectChargesId,
                        projectTaskId: this.context.projectTaskId,
                        transDate: this.mode=='Add'?this.transDate:this.context.transDate,
                        recurrence: this.context.recurrence,
                        hours: parseFloat(this.context.hours),
                        remarks: this.context.remarks==null ? '' : this.context.remarks,
                    }
                    
                    var response = null
                    if (this.mode == 'Add')
                        response = await projectChargesApi.add(data)
                    else
                        response = await projectChargesApi.update(data)

                    if (response && response.status == 200) {
                        this.loading = false
                        this.disabled = false                    
                        this.closeDialog()
                        this.$emit('send', '')
                    }
                }catch(error){
                    this.errorMessage = error
                    this.error = true
                }        
            }
        }, 
        async getProjects() {
            try{
                this.error = false
                this.loading = true
            
                const response = await projectsApi.get()
                if (response && response.status == 200) {    
                    if (response.data.items.length) {
                        const projects = response.data.items.filter(x => x.status != commonfn.getStatusCode('Completed'))
                        projects.forEach(p => {
                            this.project_list.push(
                                {
                                    projectId: p.projectId,
                                    projectName: `[${p.client}] ${p.projectCode} - ${p.projectName}`,
                                    projectTasks: p.projectTasks
                                }
                            )
                        })
                    }
                }

                this.disabled = false
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },   
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
        }
    },
    computed: {},
    created() {
        this.commonfn = commonfn
        this.avatarPath = process.env.VUE_APP_AVATARS_URL
        this.getProjects()
    }
}
</script>